import { defineMessages } from 'react-intl';

export default defineMessages({
  missionNumber: {
    id: 'expertise.table_header_titles.missionNumber',
  },
  appointedExpert: {
    id: 'expertise.table_header_titles.appointedExpert',
  },
  type: {
    id: 'expertise.table_header_titles.type',
  },
  missionDate: {
    id: 'expertise.table_header_titles.missionDate',
  },
  concernedParty: {
    id: 'expertise.table_header_titles.concerned_party',
  },
  missionStatus: {
    id: 'expertise.table_header_titles.missionStatus',
  },
  claimNumber: {
    id: 'expertise.table_header_titles.claimNumber',
  },
  rowsPerPage: {
    id: 'court_manager_page.assigned_claims_table.lines_per_page',
  },
  city: {
    id: 'expertise.table_header_titles.city',
  },
  courtNumber: {
    id: 'expertise.table_header_titles.courtNumber',
  },
  hearingDate: {
    id: 'expertise.table_header_title.hearingDate',
  },
  lawyerAdvice: {
    id: 'expertise.table_header_title.lawyerAdvice',
  },
  process: {
    id: 'expert.assigned_folders_table.process',
  },
  assignedDossier: {
    id: 'expert.assigned_folders_table.assignedDossier',
  },
  processedFiles: {
    id: 'expert.side_menu.processedDossiers',
  },
  recap: {
    id: 'expert_mission.recap',
  },
  expertise: {
    id: 'expert_mission.expertise',
  },
  action: {
    id: 'expert_mission.action',
  },
  consult: {
    id: 'expert_mission.consult',
  },
  treat: {
    id: 'expert_mission.treat',
  },
  searchResultTitle: {
    id: 'court_manager_page.assigned_claims_table.title',
  },
  nature: {
    id: 'affected_mission.cell_nature_mission.title',
  },
  judiciaryNatureTitle: {
    id: 'mission.nature_judiciary.title',
  },
  transactionNatureTitle: {
    id: 'mission.nature_transaction.title',
  },
});
